import React from 'react';
import './Researchpermission.css';

const FinnishPage = () => {
    return (
        <div>
            <p>
                <b>
                    <span lang="FI">
                        Tiedote oppimisen itsearvioinnin tutkimuksesta tutkimusetiikassa
                    </span>
                </b>
            </p>

            <p>
                <span lang="FI">
                    Reflektiokompassin kehittäjät olemme opetuksen ja oppimisen tutkijoita Helsingin
                    yliopiston kasvatustieteellisessä tiedekunnassa. Haluaisimme ymmärtää
                    itsearvioinnin käytäntöjä ja tarkkuutta tutkimusetiikan oppimisessa sekä
                    analysoida opiskelijoiden itsearviointia suhteessa heidän antamiinsa avoimiin
                    vastauksiin. Olemme myös kiinnostuneita opiskelijoiden omista arvioista ja
                    niiden suhteesta opettajan mahdolliseen arviointiin. Emme analysoi opettajan
                    antamia oppimistehtäviä.
                </span>
            </p>

            <p>
                <span lang="FI">
                    Tutkimukseen osallistuminen on vapaaehtoista. Ensin pyydämme opettajaa sallimaan
                    tämän sovelluksen kautta luotujen tietojen käytön. Jos opettaja suostuu,
                    järjestelmä lähettää pyynnön kurssin opiskelijoille. Jos opettaja kieltää
                    käyttämästä sovelluksen avulla syntyneitä tietoja, järjestelmä ei lähetä pyyntöä
                    opiskelijoille. Tietoja ei käytetä, jos opiskelija ei ole antanut suostumustaan,
                    vaikka opettaja olisi suostunut. Osallistuminen tutkimukseen auttaa meitä
                    kehittämään tutkimusetiikan opetusta.
                </span>
            </p>

            <p>
                <span lang="FI">
                    Viittaukset henkilöihin, paikkoihin tai instituutioihin anonymisoidaan. Tutkijat
                    työskentelevät vain anonymisoidun datan kanssa. Tutkimus noudattaa
                    Tutkimuseettisen neuvottelukunnan ohjeita. Emme paljasta henkilötietoja ja
                    takaamme anonyymisyytesi tutkimusraporteissa ja tieteellisissä artikkeleissa.
                    Tallennamme kaikki tiedot Helsingin yliopistoon liittyville salasanasuojatuille
                    tileille. Jos haluat vetäytyä tutkimuksesta, voit tehdä sen milloin tahansa
                    ilman syytä ja ilman sinulle aiheutuvia seurauksia. Voit vetäytyä ilmoittamalla
                    asiasta alla mainittuun sähköpostiosoitteeseen. Koska tutkijat työskentelevät
                    anonymisoidun datan kanssa, tietojasi ei ehkä ole mahdollista jäljittää tietyn
                    analyysivaiheen jälkeen.
                </span>
            </p>

            <p>
                <span lang="FI">
                    Jos sinulla on kysyttävää, ota yhteyttä: Erika Löfströmiin
                    Erika.lofstrom@helsinki.fi
                </span>
            </p>

            <p>
                <b>
                    <span lang="FI">Suostumus</span>
                </b>
            </p>

            <p>Ymmärrän, että</p>

            <p>
                <span lang="FI" className="p">
                    tutkimukseen osallistuminen on vapaaehtoista ja voin lopettaa osallistumiseni
                    milloin tahansa syytä ilmoittamatta
                </span>
            </p>

            <p>
                <span lang="FI" className="p">
                    minulla on oikeus peruuttaa suostumukseni ja pyytää tutkijoita poistamaan jo
                    kerätyt tiedot. Ymmärrän, että tässä vaiheessa tutkijoilla saattaa olla vain
                    anonymisoituja tietoja, joiden tunnistaminen ja siten poistaminen on mahdotonta
                </span>
            </p>

            <p>
                <span lang="FI" className="p">
                    tutkijat eivät luovuta henkilöllisyyttäni koskevia tietoja, tai tietoja, jotka
                    voivat johtaa henkilöllisyyteni paljastamiseen
                </span>
            </p>

            <p>
                <span lang="FI" className="p">
                    voin ottaa yhteyttä tutkijoihin, jos minulla on kysyttävää tutkimuksesta
                </span>
            </p>
        </div>
    );
};

export default FinnishPage;
